enum Role {
  ADMIN = "Admin",
  MANAGER = "Manager",
  SUPER_ADMIN = "Super Admin",
}

export default Role;
